export default __webpack_public_path__ + "static/media/logo.367545fe.webp";